import React from "react"
import "./LoginForm.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons"

function LoginForm({
  loginToSignup,
  ChangeHandlerLogin,
  Login,
  loginInfo,
  loginErrorMsg,
}) {
  const renderErrorMsg = (loginErrorMsg) => {
    if (loginErrorMsg != undefined) {
      return (
        <p className='error-message'>
          <FontAwesomeIcon icon={faExclamationCircle} />
          {loginErrorMsg}
        </p>
      )
    }
  }

  return (
    <div className='boxContainer'>
      <form className='formContainer'>
        <input
          className='inputForm'
          type='email'
          placeholder='Email'
          onChange={ChangeHandlerLogin}
          name='email'
          value={loginInfo.email}
        />
        {renderErrorMsg(loginErrorMsg)}
        <input
          className='inputForm'
          type='password'
          placeholder='Password'
          onChange={ChangeHandlerLogin}
          name='password'
          value={loginInfo.password}
        />
        {renderErrorMsg(loginErrorMsg)}
        <button
          className='submitButton'
          onClick={(e) => {
            e.preventDefault()
            Login()
          }}>
          Sign In
        </button>
        <p className='mutedLink'>
          Don't have an account?{" "}
          <button
            className='boldBtn'
            onClick={(e) => {
              loginToSignup()
            }}>
            Sign Up
          </button>
        </p>
      </form>
    </div>
  )
}

export default LoginForm
